export const SIGNUP_URL = 'https://app.giraffe.build/signup';
export const APP_URL = 'https://app.giraffe.build';
